import { createSlice } from "@reduxjs/toolkit";
import {
  DealerCodes,
  DealerDetails,
} from "../../actions/adminActions/adminDealersActions";

const initialState = {
  dealer_codes: [],
  dealer_details: [],
};

const adminDealersSlice = createSlice({
  name: "adminDealerCodes",
  initialState,
  reducers: { resetAdminDealers: () => initialState },

  extraReducers: (builder) => {
    // get dealer codes as per the seller
    builder.addCase(DealerCodes.fulfilled, (state, { payload }) => {
      state.dealer_codes = payload?.data?.data;
    });
    builder.addCase(DealerCodes.rejected, (state, action) => {
      console.error("Fetch Dealer Codes failed:", action.error.message);
    });
    // get the dealer details as per selected dealer code
    builder.addCase(DealerDetails.fulfilled, (state, { payload }) => {
      state.dealer_details = payload?.data?.data;
    });
    builder.addCase(DealerDetails.rejected, (state, action) => {
      console.error("Fetch Dealer Details failed:", action.error.message);
    });
  },
});

export const { resetAdminDealers } = adminDealersSlice.actions;

export default adminDealersSlice.reducer;
